import Cookies from 'js-cookie';
import { PLAN_GROUP_TOKEN_COOKIE_NAME } from '$lib/constants/cookie-constants';

export const PLAN_GROUP_TOKEN_URL_PARAM = 'plan_group_token';

/**
 * @returns The plan group token from the `plan_group_token` URL query parameter or the `optly_var_square-one-pnp`
 *   cookie.
 * @throws Error if the plan group token is not found in either location.
 */
export function getPlanGroupToken(): string {
  let planGroupToken: string | undefined;

  // get the plan group token value from query param
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has(PLAN_GROUP_TOKEN_URL_PARAM)) {
    planGroupToken = urlParams.get(PLAN_GROUP_TOKEN_URL_PARAM) || undefined;
  }

  if (!planGroupToken) {
    // get the plan group token from the optly_var_square-one-pnp cookie
    planGroupToken = Cookies.get(PLAN_GROUP_TOKEN_COOKIE_NAME);
  }

  if (planGroupToken === undefined || planGroupToken.toLowerCase() === 'null') {
    throw new Error(`${PLAN_GROUP_TOKEN_COOKIE_NAME} cookie is not set`);
  }

  return planGroupToken;
}
